module.exports = __webpack_public_path__ + "static/media/mockup-mobile.642dcb5f.png";